import Vue from 'vue'
import AppUtils from '@/utils/AppUtils'

function commentNode (el, vnode) {
  el.style.display = 'none'

  // const comment = document.createComment(' ')
  // Object.defineProperty(comment, 'setAttribute', {
  //   value: () => undefined
  // })
  // vnode.elm = comment
  // vnode.text = ' '
  // vnode.isComment = true
  // vnode.context = undefined
  // vnode.tag = undefined
  // vnode.data.directives = undefined

  // if (vnode.componentInstance) {
  //   vnode.componentInstance.$el = comment
  // }

  // if (el.parentNode) {
  //   el.parentNode.replaceChild(comment, el)
  // }
}

Vue.directive('debug', {
  /**
   *
   * @param {HTMLElement} el
   * @returns
   */
  bind (el, binding, vnode) {
    // doNtg
    if(binding.value === false) return
    el.setAttribute('v-debug', 'true') // refer main.css
    if (!AppUtils.isDebugMode()) {
      commentNode(el, vnode) // failsafe
      return
    }
    el.setAttribute('title','`v-debug`| This is a debug element, will be hidden in production mode')
  }
})

Vue.directive('auth', {
  bind (el, binding, vnode) {
    if (!AppUtils.isLoggedIn() && (binding.value === undefined || binding.value === true)) commentNode(el, vnode)
    if (AppUtils.isLoggedIn() && binding.value === false) commentNode(el, vnode)
  }
})

Vue.directive('roles', {
  bind (el, binding, vnode) {
    if (!AppUtils.allowAccess(false, binding.value)) commentNode(el, vnode)
  }
})

Vue.directive('permissions', {
  bind (el, binding, vnode) {
    if (!AppUtils.allowAccess(false, [], binding.value)) commentNode(el, vnode)
  }
})

Vue.directive('tooltip', {
  // This will store a reference to the tooltip element for each bound element
  tooltipEl: null,

  bind(el, binding) {
    const tooltipContent = binding.value;

    if (!tooltipContent) return; // Don't create if no content
    if (tooltipContent === null) return;

    // Create the tooltip element
    const tooltipEl = document.createElement('div');
    tooltipEl.classList.add('v-lets_tooltip');
    tooltipEl.textContent = tooltipContent;
    document.body.appendChild(tooltipEl);

    // Store a reference to the tooltip element on the bound element itself
    // This helps in accessing it later in other hooks
    el._tooltipEl = tooltipEl; // Using a custom property on the element

    const showTooltip = () => {
      // Position the tooltip
      const rect = el.getBoundingClientRect();
      tooltipEl.style.top = `${rect.bottom + window.scrollY + 8}px`; // 8px padding
      tooltipEl.style.left = `${Math.max((rect.left + window.scrollX + (rect.width / 2) - (tooltipEl.offsetWidth / 2)), 0) }px`;
      tooltipEl.classList.add('v-lets_tooltip--visible');
    };

    const hideTooltip = () => {
      tooltipEl.classList.remove('v-lets_tooltip--visible');
    };

    // Attach event listeners
    el.addEventListener('mouseenter', showTooltip);
    el.addEventListener('mouseleave', hideTooltip);
    el.addEventListener('focus', showTooltip); // For keyboard accessibility
    el.addEventListener('blur', hideTooltip);

    // Store references to the event handlers for cleanup
    el._showTooltipHandler = showTooltip;
    el._hideTooltipHandler = hideTooltip;

    showTooltip();
    hideTooltip();
  },

  update(el, binding) {
    // If the tooltip content changes, update the text
    if (el._tooltipEl && binding.value !== binding.oldValue) {
      el._tooltipEl.textContent = binding.value;
      // Re-position in case content width changed
      if (el._tooltipEl.classList.contains('v-tooltip--visible')) {
        const rect = el.getBoundingClientRect();
        el._tooltipEl.style.left = `${rect.left + window.scrollX + (rect.width / 2) - (el._tooltipEl.offsetWidth / 2)}px`;
      }
    }
  },

  unbind(el) {
    // Remove event listeners
    if (el._showTooltipHandler) {
      el.removeEventListener('mouseenter', el._showTooltipHandler);
      el.removeEventListener('mouseleave', el._hideTooltipHandler);
      el.removeEventListener('focus', el._showTooltipHandler);
      el.removeEventListener('blur', el._hideTooltipHandler);
    }

    // Remove the tooltip element from the DOM
    if (el._tooltipEl) {
      document.body.removeChild(el._tooltipEl);
      delete el._tooltipEl; // Clean up the reference
    }
  },
});

// -- Becky Specific -- //

Vue.directive('phase2', {
  bind (el, binding, vnode) {
    if (!import.meta.env.PHASE2) commentNode(el, vnode)
  }
})

// https://v2.vuejs.org/v2/guide/custom-directive#Function-Shorthand
Vue.directive('highlight-braces', function (el, binding, vnode, oldVnode) {
  // Get the value of the directive
  let text = binding.value

  if (text && vnode.children && vnode.children.length > 0) {
    console.warn('v-highlight-braces:The directive is used as a modifier. Child element will be ignored.', el)
  }
  if (!text) {
    // Get the text content of the element if no value is provided
    text = vnode.children[0].text
    if (vnode.children.length > 1) { console.warn('v-highlight-braces:Multiple child elements found. Only the first child element will be used.', el) }
  }
  if (!text) console.warn('v-highlight-braces:No text content found. Use v-highlight-braces="\'text\'" or add text content inside the element.', el)
  // Check if the text contains '{' and '}'
  if (text && text.includes('{') && text.includes('}')) {
    // If it does, split the text into parts using '{' and '}'
    const parts = text.split(/({.*?})/)

    // Create a new array to hold the modified parts
    const highlightedParts = []

    // Loop through each part
    parts.forEach(part => {
      // If the part starts and ends with '{' and '}', respectively
      if (part.startsWith('{') && part.endsWith('}')) {
        // Remove the braces and wrap the part in a span with Vuetify's primary color class and inherit font style
        const highlightedText = part.substring(1, part.length - 1)
        highlightedParts.push(`<span style="font-family: inherit;color: var(--v-primary-base);">${highlightedText}</span>`)
      } else {
        // Otherwise, keep the part as it is
        highlightedParts.push(part)
      }
    })

    // Set the innerHTML of the element to the modified parts
    el.innerHTML = highlightedParts.join('')
  }
})

Vue.directive('bold-braces', function (el, binding, vnode, oldVnode) {
  // Get the value of the directive
  let text = binding.value

  if (text && vnode.children && vnode.children.length > 0) {
    console.warn('v-bold-braces:The directive is used as a modifier. Child element will be ignored.', el)
  }
  if (!text) {
    // Get the text content of the element if no value is provided
    text = vnode.children[0].text
    if (vnode.children.length > 1) { console.warn('v-bold-braces:Multiple child elements found. Only the first child element will be used.', el) }
  }
  if (!text) console.warn('v-bold-braces:No text content found. Use v-bold-braces="\'text\'" or add text content inside the element.', el)
  // Check if the text contains '{' and '}'
  if (text && text.includes('{') && text.includes('}')) {
    // If it does, split the text into parts using '{' and '}'
    const parts = text.split(/({.*?})/)

    // Create a new array to hold the modified parts
    const boldedParts = []

    // Loop through each part
    parts.forEach(part => {
      // If the part starts and ends with '{' and '}', respectively
      if (part.startsWith('{') && part.endsWith('}')) {
        // Remove the braces and wrap the part in a span with Vuetify's primary color class and inherit font style
        const boldedText = part.substring(1, part.length - 1)
        boldedParts.push(`<span style="font-family: inherit;font-weight: bold;">${boldedText}</span>`)
      } else {
        // Otherwise, keep the part as it is
        boldedParts.push(part)
      }
    })

    // Set the innerHTML of the element to the modified parts
    el.innerHTML = boldedParts.join('')
  }
})

Vue.directive('mobile-long-press', {
  bind: function (el, binding) {
    if (!window.vue.$vuetify.breakpoint.mobile) return

    let pressTimer = null;

    const start = (e) => {
      // Block iOS context menu
      e.preventDefault();

      // Set timeout only if it’s not already set
      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          binding.value(e); // Call the method passed to directive
        }, 600); // Customize press time here
      }
    };

    const cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer);
        pressTimer = null;
      }
    };

    // Add touch and mouse listeners
    el.addEventListener('touchstart', start, { passive: true });
    el.addEventListener('touchend', cancel);
    el.addEventListener('touchmove', cancel);
    el.addEventListener('touchcancel', cancel);
    el.addEventListener('mousedown', start);
    el.addEventListener('mouseup', cancel);
    el.addEventListener('mouseleave', cancel);

    // Optional: prevent context menu on long press (iOS fallback)
    el.addEventListener('contextmenu', e => e.preventDefault());
  },
  unbind: function (el) {
    // Clean up listeners if needed
  }
});

